import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Box,
  Button,
  CircularProgress,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useToast } from "../../../components/Toast";
import { inventoryApi } from "./apiService";
import { smallButtonProp } from "../../../utils/styles";

interface UnallocateItemModalProps {
  open: boolean;
  onClose: () => void;
  item: any; // Inventory item to unallocate
  category: string; // Category of the item (e.g., "Tyre", "Battery", etc.)
  fetchInventoryItems: () => void;
  onReallocate: any;
  reallocate?: boolean;
}

const UnallocateItemModal: React.FC<UnallocateItemModalProps> = ({
  open,
  onClose,
  item,
  fetchInventoryItems,
  onReallocate,
  reallocate = false,
}) => {
  const { showToast } = useToast();
  const [loading, setLoading] = useState(false);
  const handleUnallocate = async () => {
    try {
      setLoading(true);
      await inventoryApi.unallocateItem(item.masterAllocation.id);
      showToast("Item Unassigned successfully!", "success");
      onClose();
      fetchInventoryItems();
    } catch (error) {
      showToast("Failed to Unassign item. Please try again.", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ fontWeight: 600, pb: 1 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography
            variant="h6"
            component="span"
            sx={{ fontSize: "0.75rem" }}
          >
            Unassign Item
          </Typography>
          {/* <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{ color: "grey.500" }}
          >
            <CloseIcon />
          </IconButton> */}
        </Box>
      </DialogTitle>
      <DialogContent sx={{ pb: 3, pt: 2 }}>
        <Typography variant="body2" sx={{ mb: 1, fontSize: "0.85rem" }}>
          Are you sure you want to unassign{" "}
          <strong>{item?.name || item?.itemName || item?.partNumber}</strong>{" "}
          from{" "}
          <strong>
            {item?.masterAllocation?.vehicle?.vehicleNumber ||
              "current vehicle"}
          </strong>
          ?
        </Typography>

        {reallocate && (
          <Typography
            variant="body2"
            sx={{ mb: 1, color: "text.secondary", fontSize: "0.75rem" }}
          >
            Since this is a tyre item, you can also choose to reassign it to a
            different vehicle.
          </Typography>
        )}

        <Box display="flex" justifyContent="space-between" gap={2} mt={2}>
          <Button
            variant="outlined"
            color="inherit"
            onClick={onClose}
            // sx={{ px: 2, py: 0.5, fontSize: "0.8rem" }}
            {...smallButtonProp}
            disabled={loading}
          >
            Cancel
          </Button>

          {reallocate && (
            <Button
              variant="contained"
              color="primary"
              onClick={onReallocate}
              // sx={{ px: 2, py: 0.5, fontSize: "0.8rem" }}
              {...smallButtonProp}
              disabled={loading}
            >
              Reassign
            </Button>
          )}

          <Button
            variant="contained"
            color="warning"
            onClick={handleUnallocate}
            // sx={{ px: 2, py: 0.5, fontSize: "0.8rem" }}
            {...smallButtonProp}
            disabled={loading}
          >
            {loading ? (
              <CircularProgress size={20} color="inherit" />
            ) : (
              "Unassign"
            )}
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default UnallocateItemModal;
